<template>
    <div class="watch">
        <template v-if="!loadingMovie && !errorMovie">
            <div class="player-wrapper">
                <div v-if="!loadingVideoToPlay && !errorVideoToPlay">
                    <VideoPlayer
                        v-if="videoToPlay"
                        :video="videoToPlay"
                        @videoEnded="videoEndedHandler"
                        @videoStarted="videoStartedHandler"
                        :showOverlay="videoToPlayShowTrailerEndingPromo"
                        :movie="movie"
                    >
                        <template slot="overlay" >
                            <div
                                class="player-overlay-subscribe"
                                :style="{ backgroundImage: `url('${movie.public_thumbnail_image_path['large']}')` }"
                            >
                            </div>
                        </template>
                    </VideoPlayer>
                    <div class="text">
                      <h4 class="name">{{movie.name}}</h4>
                      <p class="description">{{movie.description}}</p>
                    </div>
                    <div v-if="!videoToPlay">
                        <div
                            :style="{ backgroundImage: `url('${movie.public_thumbnail_image_path['large']}')` }"
                            class="no-trailer-thumbnail"
                            @click="subscribeHandler"
                        ></div>
                    </div>
                </div>
                
                <div v-else class="video-box-fallback">
                    <p v-if="errorVideoToPlay">{{$t('error')}}</p>
                    <Spinner v-if="loadingVideoToPlay"/>
                </div>
            
            </div>
        </template>
        
        
        
        <template v-else>
            <div
                class="loading-video"
                v-if="loadingMovie"
            >
                <Spinner/>
            </div>
            <div
                class="error-video"
                v-if="errorMovie"
            >
                {{$t('video_watch.not_available')}}
            </div>
        </template>
    
    </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer";
import Spinner from "../../Spinner";
import resources from '../../../resources';

export default {
    props:['movieId'],
    components: {
        Spinner,
        VideoPlayer,
    },
    data(){
        return {
            movie: null,
            loadingMovie: true,
            errorMovie: false,
            
            videoToPlay: null,
            errorVideoToPlay: false,
            videoToPlayIsMain: false,
            loadingVideoToPlay: false,
            videoToPlayShowTrailerEndingPromo: false,
            
            reportedView: false,
        }
    },
    methods: {
        videoStartedHandler(){
            if (!this.reportedView && this.videoToPlayIsMain){
                this.reportView();
            }
            
            this.videoToPlayShowTrailerEndingPromo = false;
        },
        videoEndedHandler(){
            if(!this.videoToPlayIsMain){
                this.videoToPlayShowTrailerEndingPromo = true;
            }
        },
        subscribeHandler(){
            this.$router.push({name: 'subscribe'});
        },
        
        loadMovie(id){
            this.movie = null;
            this.errorMovie = false;
            this.loadingMovie = true;
            
            this.videoToPlay = null;
            this.videoToPlayIsMain = false;
            this.loadingVideoToPlay = false;
            this.errorVideoToPlay = false;
            this.videoToPlayShowTrailerEndingPromo = false;
            
            resources.movies.get({id: id, include: ['categories', 'models', 'tags', 'group.movies']})
                .then(response => {
                    this.movie = response.data.data;
                    this.errorMovie = false;
                    this.loadingMovie = false;
                    
                    /* Si el video puede ser reproducido, cargamos el video, Si no mostramos el trailer */
                    if (this.movie.main_video_id){ /* El main movie id viene vacio si no tenemos acceso */
                        
                        this.videoToPlayIsMain = true;
                        this.loadVideo(this.movie.main_video_id);
                        
                    }else if(this.movie.trailer_video_id){
                        
                        this.loadVideo(this.movie.trailer_video_id);
                        
                    }else{
                        
                        //this.errorMovie = true;
                        //console.error('No hay video disponible');
                    }
                    /* Si el video puede ser reproducido, cargamos el video, Si no mostramos el trailer */
                }).catch(err => {
                
                this.loadingMovie = false;
                this.errorMovie = true;
            });
        },
        
        loadVideo(videoId){
            this.videoToPlay = null;
            this.loadingVideoToPlay = true;
            this.errorVideoToPlay = false;
            
            resources.videos.get({id: videoId, cdn_cache_optimizer: Math.random() * 1000000000})
                .then((response) => {
                    this.videoToPlay = response.data.data;
                    this.loadingVideoToPlay = false;
                    this.errorVideoToPlay = false;
                    
                }).catch((err) => {
                this.loadingVideoToPlay = false;
                this.errorVideoToPlay = true;
            })
        },
        
        reportView(){
            this.reportedView = true;
            resources.movieView.store({movie_id: this.movie.id}).then(() => {
                this.$set(this.movie, 'views', this.movie.views + 1);
            });
        },
        
        
    },
    watch:{
        movie(){
            this.reportedView = false;
        }
    },
    mounted(){
        this.loadMovie(this.movieId);
    },
    beforeRouteUpdate (to, from, next) {
        this.loadMovie(to.params.id);
        
        next();
    },
    beforeDestroy(){
        clearTimeout(this.viewTimeout);
    }
}
</script>

<style scoped lang="scss">
@import '../../../styles/variables';

.watch{
    //padding: 30px 0 50px;
    
    .no-trailer-thumbnail{
        background-color: #000000;
        height: 500px;
        width: 100%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    
    .video-box-fallback{
        background-color: lightgrey;
        height: 500px;
        width: 100%;
        text-align: center;
        padding: 1em;
    }
    
    .player-wrapper{
        display: block;
        margin: auto;
        //max-width: 70%;
        
        @media(max-width: 900px){
            max-width: 100%;
        }
        
        .text{
          margin: 5px 0 50px;
          text-align: left;
          .name{
            //text-transform: capitalize;
            margin: 0 0 10px 0;
          }
          .description{
            margin: 0;
            color: grey;
            //text-transform: capitalize;
          }
        }
        
        .details{
            .stats{
                user-select: none;
                overflow: hidden;
                padding: 10px 0;
                font-size: .85em;
                line-height: 1em;
                
                .left{
                    float: left;
                }
                
                .right{
                    float: right;
                }
                
                .rating{
                    float: left;
                    cursor: pointer;
                    
                    &.liked{
                        font-weight: bold;
                    }
                    
                    &:before{
                        //vertical-align: bottom;
                        content:"";
                        background-image: url('/img/ico/thumb-up.svg');
                        //font-weight: bolder;
                        //font-size: 2em;
                        
                    }
                }
                .favorites{
                    margin-left: 1em;
                    float: left;
                    cursor: pointer;
                    
                    &.favorited{
                        font-weight: bold;
                    }
                    
                    &:before{
                        vertical-align: bottom;
                        //content: '♥';
                        font-weight: bolder;
                        font-size: 2em;
                    }
                }
                .view-count{
                    font-weight: bolder;
                }
            }
            
            .information{
                margin-top: 15px;
                text-align: left;
                
                p{
                    margin: 0;
                    
                    a{
                        text-decoration: underline;
                        margin: 0 5px;
                    }
                }
            }
        }
        
    }
    .more-from-same-models{
        margin-bottom: 75px;
        margin-top: 35px;
        
        .title{
            font-size: 40px;
            text-transform: uppercase;
            color: $pallete_main_color;
            margin: 0 0 20px 0;
            
            @media (max-width: 900px){
                font-size: 1.25em;
            }
        }
        
        .movie{
            width: 300px;
        }
    }
    
    .more-from-same-group{
        margin-bottom: 75px;
        margin-top: 35px;
        
        .title{
            font-size: 1.4em;
            text-align: left;
            margin: 5px;
            margin-bottom: 15px;
            text-transform: uppercase;
        }
        
        .videos{
            display: flex;
            flex-wrap: wrap;
            
            .video{
                flex-basis: 25%;
                flex-grow: 0;
                
                @media(max-width: 900px){
                    flex-basis: 50%;
                }
                
                @media(max-width: 600px){
                    flex-basis: 100%;
                }
            }
        }
    }
    
    .related-videos{
        
        .title{
            font-size: 1.4em;
            text-align: left;
            margin: 5px;
            margin-bottom: 15px;
            text-transform: uppercase;
        }
        
        .movie{
            width: 300px;
            
            &.horizontal{
                width: 500px;
            }
        }
    }
}

.player-overlay-subscribe{
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    
    user-select: none;
    background-color: $pallete_main_color;
    color: #ffffff;
    padding: .5em;
    font-weight: bold;
    text-transform: uppercase;
    height: 100%;
    opacity: .9;
    
    .alert-box{
        cursor: pointer;
        color: $pallete_main_color;
        padding: 1em;
        background-color: rgba(255,255,255,.75);
        box-shadow: 2px 2px 2px rgba(0,0,0, .5);
    }
    
    .close{
    
    }
}
</style>